import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useSubscription } from "@/contexts/SubscriptionContext";
import { StarIcon, CheckCircle } from "lucide-react";

interface UpgradeModalProps {
  isOpen: boolean;
  onClose: () => void;
  featureName: string;
  handleUpgrade: () => void;
  isPro: boolean;
}

const UpgradeModal: React.FC<UpgradeModalProps> = ({
  isOpen,
  onClose,
  featureName,
  handleUpgrade,
  isPro,
}) => {
  const { upgradeSubscription } = useSubscription();
  // const [upgrading, setUpgrading] = React.useState(false);

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center text-xl">
            <StarIcon className="h-5 w-5 mr-2 text-amber-500" />
            Upgrade to PRO
          </DialogTitle>
          <DialogDescription>
            Unlock {featureName} and many more advanced features with our PRO
            plan.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 py-4">
          <div className="bg-amber-50 rounded-lg p-4 border border-amber-200">
            <h4 className="font-medium text-amber-900 mb-2">
              PRO Plan Features
            </h4>
            <ul className="space-y-2">
              <li className="flex items-start">
                <CheckCircle className="h-5 w-5 text-amber-600 mr-2 flex-shrink-0 mt-0.5" />
                <span>Multiple ticket types (Early Bird, VIP, etc.)</span>
              </li>
              <li className="flex items-start">
                <CheckCircle className="h-5 w-5 text-amber-600 mr-2 flex-shrink-0 mt-0.5" />
                <span>Custom registration fields</span>
              </li>
              <li className="flex items-start">
                <CheckCircle className="h-5 w-5 text-amber-600 mr-2 flex-shrink-0 mt-0.5" />
                <span>Advanced event analytics</span>
              </li>
              <li className="flex items-start">
                <CheckCircle className="h-5 w-5 text-amber-600 mr-2 flex-shrink-0 mt-0.5" />
                <span>Priority support</span>
              </li>
            </ul>
          </div>

          <div className="text-center">
            <p className="text-2xl font-bold">
              $19
              <span className="text-base font-normal text-gray-500">
                /month
              </span>
            </p>
            <p className="text-sm text-gray-500">Cancel anytime</p>
          </div>
        </div>

        <DialogFooter className="sm:justify-between">
          <Button variant="outline" onClick={onClose}>
            Not Now
          </Button>
          <Button
            onClick={handleUpgrade}
            className="bg-amber-600 hover:bg-amber-700"
            disabled={isPro}
          >
            {isPro ? "Upgrading..." : "Upgrade Now"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default UpgradeModal;
